import {useMemo} from 'react';
import {IProduct} from '../../../../../types/galleryTypes';
import {useGlobals} from '../../../../../globalPropsContext';
import {hasBlockingFeatures, supportsDirectAddToCartFromGallery} from '../../../../../services/addToCartFlowUtils';
import {Experiments} from '../../../../../constants';

export function useShouldHideQuickAddInEditor(product: IProduct, quickAddOptionsLength: number): boolean {
  const {styles, stylesParams, isEditorMode, useExperiments} = useGlobals();

  return useMemo(() => {
    if (!isEditorMode) {
      return false;
    }

    const supportsDirectAddToCart = supportsDirectAddToCartFromGallery({
      options: product.options,
      isProductOptionsEnabled: styles.get(stylesParams.gallery_showProductOptionsButton),
      isShowOnlyColorOptionsEnabled: styles.get(stylesParams.gallery_showColorOptionsOnly),
      productOptionsDisplayOption: styles.get(stylesParams.gallery_productOptionsDisplayOption),
      isShowFirstProductOptionInGalleryExperimentEnabled: useExperiments.enabled(
        Experiments.ShouldShowFirstProductOptionInGallery
      ),
    });

    return hasBlockingFeatures(product) || supportsDirectAddToCart || quickAddOptionsLength === 0;
  }, [isEditorMode, product, styles, stylesParams, useExperiments, quickAddOptionsLength]);
}
